module.exports = __webpack_public_path__ + "static/media/invitation-pending.bdcf7419.svg";